import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';

class VisTekstDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.text,
      buttonTitle: props.buttonTitle,
      open: false
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };


  componentWillReceiveProps(props) {
      this.setState({
        text: props.text,        
        buttonTitle: props.buttonTitle
      })    
  }

  render() {
    return (
      <div> 
        <Button id='btnVisTekstDialog' onClick = {this.handleOpen} color="primary">
          {this.state.buttonTitle}
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >          
          <DialogContent>
            <Typography>{this.state.text}</Typography>
          </DialogContent>
          <DialogActions>
            <Button id='btnLukkTekstDialog' onClick={this.handleClose} color="primary">
              Lukk
            </Button>            
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

export default VisTekstDialog;